interface Config {
    API_BASE_URL: string;
    API_KEY: string;
    TITLE: string;
    AZURE_CLIENT_ID: string;
    AZURE_TENANT_ID: string;
    REDIRECT_URI: string;
}

export const config: Config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
    API_KEY: process.env.REACT_APP_API_KEY || '',
    TITLE: process.env.REACT_APP_TITLE || '',
    AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID || '',
    REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI || ''
}; 

